/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useModal } from "../../../context/ModalContext";
import { CloseIcon } from "../../../components/Icons";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { useReasonForVisitV2 } from "../../../services/reason-for-visitV2/reason-for-visit.service-v2";
import { useUserDetail } from "../../../services/user-detail/user-detail.service";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import PetCard from "./PetCard";
import { useNavigate } from "react-router-dom";
import { PAGES_PATH } from "../../../navigation/params";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { EXPIRE_PAYMENT_ALERT_TYPES } from "../../../config/params";
import { useCombinedAlertsDataStore } from "../../../hooks";

export const getAlertTypeConfig = (alertType?: string) => {
  const defaultConfig = {
    header: (petName: string) => `${petName}'s Wellness Plan Payment Method Needs Attention`,
    body: (petName: string) => `There's an issue with your payment method for ${petName}. Please double-check your card details.`,
    cta: "Update Now",
  };

  if (!alertType || !(alertType in EXPIRE_PAYMENT_ALERT_TYPES)) {
    return defaultConfig;
  }

  return EXPIRE_PAYMENT_ALERT_TYPES[alertType as keyof typeof EXPIRE_PAYMENT_ALERT_TYPES];
};

const WellnessPlanUpdatePopUpModal = () => {
  const { closeModal } = useModal();
  const { updatePaymentMethod } = useCombinedAlertsDataStore();
  const navigate = useNavigate();
  const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toLocaleUpperCase() + string.substring(1);
  };
  const [open, setOpen] = useState(true);

  useEffect(() => {
    const hideUntilOneHour = localStorage.getItem("updateWlnsPlanNtfn");

    if (hideUntilOneHour && new Date() < new Date(hideUntilOneHour)) {
      localStorage.removeItem("updateWlnsPlanNtfn");
      setOpen(false);
    }
  }, []);


  const formatPetNames = (petNames: string[]): string => {
    if (!petNames || petNames.length === 0) return "";

    const capitalizedNames = petNames.map(capitalizeFirstLetter);

    if (capitalizedNames.length === 1) return capitalizedNames[0];

    if (capitalizedNames.length === 2) {
      return capitalizedNames.join(" and ");
    }

    if (capitalizedNames.length === 3) {
      return `${capitalizedNames.slice(0, -1).join(", ")} and ${capitalizedNames[capitalizedNames.length - 1]}`;
    }

    return `${capitalizedNames.slice(0, 3).join(", ")} & ${capitalizedNames.length - 3} more`;
  };

  const handleCloseModal = ()=>{
    const hideUpsellUntilDate = new Date();

    hideUpsellUntilDate.setDate(hideUpsellUntilDate.getDate() + 1);
    localStorage.setItem("updateWlnsPlanNtfn", hideUpsellUntilDate.toISOString());
    closeModal();
  };

  const handleCloseModalAndRedirect = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    handleCloseModal();
    userActivityLogger(MIXPANEL_EVENTS.USER_CLICK_UPDATE_PAYMENT_FROM_POP_UP, {
      pet_name: updatePaymentMethod && updatePaymentMethod.length === 1 ? updatePaymentMethod[0].petName : updatePaymentMethod?.map((pet)=>(pet.petName)).join(", "),
    });
    if (updatePaymentMethod && updatePaymentMethod.length === 1) {
      navigate(`${PAGES_PATH.MANAGE_PLAN}?id=${updatePaymentMethod[0].animalId}`);
    } else {
      navigate(`${PAGES_PATH.USER_PROFILE}/${PAGES_PATH.USER_BILLING}`);
    }
  };

  if (!open) {
    return null;
  }

  return (
    <div className="h-full flex flex-col justify-between">
      <div className="w-full flex justify-end">
        <CloseIcon
          onClick={handleCloseModal}
          className="text-light-black cursor-pointer"
        />
      </div>
      <div className={`h-full flex flex-col items-center gap-3
       scrollbar-thin overflow-y-auto`}>
        {updatePaymentMethod && updatePaymentMethod.length > 0 &&
        <PetCard
          petsName={formatPetNames(updatePaymentMethod.map((pet)=>(pet.petName)))}
          expiredPetList= { updatePaymentMethod }
        />}
        <div className="text-center bg-taupe-15 rounded-lg text-sm mx-2 py-2 px-9">
          {updatePaymentMethod && updatePaymentMethod.length === 1 ?
            <p>
              {getAlertTypeConfig(updatePaymentMethod[0].alertType).body(updatePaymentMethod[0].petName)}
            </p>:
            <p>
              We’ve noticed an issue with your subscription payment method.
              To ensure your subscription processes smoothly, please double-check your card details.
            </p>}
        </div>
      </div>
      <div className="flex flex-col gap-4 pb-1 pt-6">
        <StyledBookingFlowButton
          color="primary"
          disabled={false} // add disable conditions if any
          size="small"
          className="w-full"
          onClick={handleCloseModalAndRedirect}
        >
          {getAlertTypeConfig(updatePaymentMethod?.[0]?.alertType).cta}
        </StyledBookingFlowButton>
      </div>
    </div>
  );
};

export default WellnessPlanUpdatePopUpModal;
